export const normalizeQldMobile = value => String(value || '').trim().replace(/[\s()-]/g, '');

export const isValidQldMobile = value => /^\+?\d{8,15}$/.test(normalizeQldMobile(value));

export const getQldMobile = (student = {}) => String(
    student.mobile || student.phone || student.contactNumber
    || student.responses?.eoi?.mobile || student.responses?.eoi?.phone
    || student.responses?.eoi?.contactNumber || ''
).trim();
